import { render, staticRenderFns } from "./BriefingIssue.vue?vue&type=template&id=723caf40&scoped=true"
import script from "./BriefingIssue.vue?vue&type=script&lang=js"
export * from "./BriefingIssue.vue?vue&type=script&lang=js"
import style0 from "./BriefingIssue.vue?vue&type=style&index=0&id=723caf40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723caf40",
  null
  
)

export default component.exports